import React from 'react';
import type {
  FieldPath,
  UseFormSetValue,
  UseFormGetValues,
} from 'react-hook-form';
import { MuiAutocomplete, TextField } from '@cherre-frontend/ui';
import { type MappingFieldsTableValues } from 'src/products/models-library/schema';

interface AutocompleteFieldProps {
  label: string;
  name: FieldPath<MappingFieldsTableValues>;
  options: Array<{ label: string; value: string }>;
  disabled?: boolean;
  setMappingValues: UseFormSetValue<MappingFieldsTableValues>;
  getMappingValues: UseFormGetValues<MappingFieldsTableValues>;
}

export const MappingTableAutocompleteField = ({
  name,
  label,
  getMappingValues,
  setMappingValues,
  options,
  disabled,
}: AutocompleteFieldProps) => {
  const value = getMappingValues(name);
  const valueAsString = typeof value === 'string' ? value : '';
  const onChange = (value: string) => setMappingValues(name, value);

  return (
    <MuiAutocomplete
      fullWidth
      options={options}
      disabled={disabled}
      value={options.find(({ value }) => value === valueAsString) || null}
      onChange={(_, data) => onChange(data ? data.value : '')}
      isOptionEqualToValue={(option, value) => option.value === value?.value}
      renderInput={(params) => (
        <TextField {...params} label={label} variant='standard' fullWidth />
      )}
    />
  );
};
